import React, { useEffect, useState } from "react";
import axios from "axios";
import { io } from "socket.io-client";
import { useAuth } from "../../context/AuthContext";
import "../../style/FeedPublicaciones.css";

export default function FeedPublicaciones({ API, SOCKET_URL }) {
  const { token, user, logout } = useAuth();
  const [publicaciones, setPublicaciones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  /* =====================================================
     📌 CARGAR PUBLICACIONES
  ===================================================== */
  useEffect(() => {
    if (!token || !user) return;

    const fetchPublicaciones = async () => {
      setCargando(true);

      try {
        const res = await axios.get(`${API}/publicaciones`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setPublicaciones(res.data || []);
      } catch (err) {
        console.error(err);

        if (err.response?.status === 403) {
          logout();
          alert("⚠️ Sesión expirada");
        } else {
          setError("❌ No se pudieron cargar las publicaciones.");
        }
      } finally {
        setCargando(false);
      }
    };

    fetchPublicaciones();
  }, [API, token, user, logout]);


  /* =====================================================
     📡 SOCKET REAL TIME
  ===================================================== */
  useEffect(() => {
    if (!token || !user) return;

    const socket = io(SOCKET_URL, {
      auth: {
        token,
        tenant_id: user.tenant_id,
      },
      transports: ["websocket"],
    });

    socket.on("post:created", (pub) => {
      if (
        pub.tenant_id === user.tenant_id &&
        (pub.sede_id === null || pub.sede_id === user.sede_id)
      ) {
        setPublicaciones((prev) => [pub, ...prev]);
      }
    });

    return () => socket.disconnect();
  }, [SOCKET_URL, token, user]);


  /* =====================================================
     📌 ESTADOS
  ===================================================== */
  if (cargando) return <p>⏳ Cargando publicaciones...</p>;
  if (error) return <p>{error}</p>;
  if (!publicaciones.length) return <p>No hay publicaciones aún.</p>;


  /* =====================================================
     📌 RENDER
  ===================================================== */
  return (
    <div className="feed-container">

      {publicaciones.map((p) => (
        <div key={p.id} className="publicacion-card">

          {/* HEADER */}
          <div className="publicacion-header">
            <span className="publicacion-autor">
              {p.nombre} {p.apellido} ({p.role})
            </span>

            <span className="publicacion-fecha">
              {new Date(p.fecha_publicacion).toLocaleString("es-CO")}
            </span>
          </div>

          {/* TEXTO */}
          {p.descripcion && (
            <p className="publicacion-contenido">
              {p.descripcion}
            </p>
          )}

          {/* IMAGEN (DEBUG + CLOUDINARY REAL) */}
          {p.imagen_url ? (
            <img
              src={p.imagen_url}
              alt="publicación"
              className="publicacion-imagen"
              loading="lazy"

              onLoad={() =>
                console.log("✔ imagen cargada:", p.imagen_url)
              }

              onError={(e) => {
                console.log("❌ error imagen:", p.imagen_url);
                e.target.style.display = "none";
              }}
            />
          ) : null}

        </div>
      ))}

    </div>
  );
}